import React from 'react'

const Spinner = () => {
    return (
        <div>
            <div className="text-center mt-5">
                <div className="spinner-border text-secondary" role="status" />
            </div>
        </div>
    )
}

export default Spinner
